import { z } from "zod";
import { CURRENCIES } from "./money.js";
import { expenseCategorySchema } from "./category.js";
import { SPLIT_MODES } from "./split.js";

/**
 * La cronologia di un gruppo: spese e pareggi insieme, dal più recente.
 *
 * Un pareggio non «salda» delle spese specifiche — nel modello di Qota
 * compensa il saldo netto — quindi non esiste una spesa saldata e una no. Il
 * confine che ha senso mostrare è **temporale**: gli istanti in cui tutti sono
 * andati a zero. Tutto ciò che precede l'ultimo di questi è chiuso davvero.
 */

const base = {
  id: z.string(),
  occurredAt: z.string(),
  amountCents: z.number().int(),
  currency: z.enum(CURRENCIES),
  /** `true` se dopo questo movimento tutti erano in pari. */
  balancedAfter: z.boolean(),
  /** `true` se appartiene a un periodo già chiuso: l'interfaccia lo collassa. */
  inClosedPeriod: z.boolean(),
};

export const timelineEntryResponseSchema = z.discriminatedUnion("kind", [
  z.object({
    ...base,
    kind: z.literal("expense"),
    description: z.string(),
    splitMode: z.enum(SPLIT_MODES),
    category: expenseCategorySchema,
    payerNames: z.array(z.string()),
    myShareCents: z.number().int().nullable(),
    participantCount: z.number().int().nonnegative(),
  }),
  z.object({
    ...base,
    kind: z.literal("settlement"),
    fromDisplayName: z.string(),
    toDisplayName: z.string(),
  }),
]);
export type TimelineEntryResponse = z.infer<typeof timelineEntryResponseSchema>;

export const groupTimelineResponseSchema = z.object({
  entries: z.array(timelineEntryResponseSchema),
  /** L'istante dell'ultimo azzeramento. `null` se non è mai successo. */
  lastBalancedAt: z.string().nullable(),
  /** Quante voci stanno nel periodo chiuso, per l'etichetta del riquadro. */
  closedCount: z.number().int().nonnegative(),
});
export type GroupTimelineResponse = z.infer<typeof groupTimelineResponseSchema>;
